export default __webpack_public_path__ + "static/media/smartalarms.9bb049e6.png";